if (!customElements.get('brand-logos-page-slider')) {
  customElements.define(
    'brand-logos-page-slider',
    class BrandLogosPageSlider extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enableSlider !== 'true') return;
        if (!this.querySelector('.swiper-wrapper')) return;

        this.sectionContent = this.closest('.section__content');
        if (!this.sectionContent) return;

        const nextEl = this.sectionContent.querySelector('.swiper-button-next');
        const prevEl = this.sectionContent.querySelector('.swiper-button-prev');
        if (!nextEl || !prevEl) return;

        this.options = {
          slidesPerView: 1,
          spaceBetween: 0,
          threshold: 2,
          watchSlidesProgress: true,
          loop: false,
          navigation: {
            nextEl,
            prevEl,
          },
        };

        this.carousel = new window.FoxTheme.Carousel(this, this.options);
        this.carousel.init();
      }

      disconnectedCallback() {
        if (this.carousel?.slider) {
          try {
            this.carousel.slider.destroy(true, true);
          } catch (_) {}
          this.carousel = null;
        }
      }
    }
  );
}
